import React, { useEffect } from 'react';

import { getIsHTTPS } from 'components/partials/AddCreditCardDialog/tools/CreditCardFormUtils';
// eslint-disable-next-line import/named
import { hashHistory, RouteComponentProps } from 'react-router';

import { Page } from '../../components/layouts';
import { AddCreditCardDialog } from '../../components/partials';
import { Track } from '../../weborder/analytics';
import { DispatchProps, StateProps } from '../../weborder/component/CreditCard';
import { domUtils } from '../../weborder/utils';

const isDev = process.env.NODE_ENV === 'development';

type CardRoute = RouteComponentProps<
  {
    backurl: string;
  },
  any
>;

type Props = StateProps & DispatchProps & CardRoute;

export function AddCreditCard(props: Props): JSX.Element {
  const { params } = props;

  useEffect(() => {
    if (!isDev && !getIsHTTPS()) {
      hashHistory.replace('/where');
    }
  }, []);

  useEffect(() => {
    domUtils.skipToContent();
  }, []);

  const handleOnSuccess = () => {
    if (params.backurl) {
      hashHistory.push(params.backurl.substring(1));
    } else {
      hashHistory.goBack();
    }

    Track('Payments', 'Add New Card Done');
  };

  const handleOnFail = () => {
    Track('Payments', 'Add New Card Failure');
  };

  const isFromCheckoutPage = document.location.hash.indexOf('checkout') !== -1;

  return (
    <Page pageName="add-credit-card">
      <AddCreditCardDialog
        isFromCheckoutPage={isFromCheckoutPage}
        onSuccess={handleOnSuccess}
        onFail={handleOnFail}
      />
    </Page>
  );
}
